window.get_formset_config = function(prefix, extras) {
    return $.extend({
        prefix: prefix,
        formCssClass: prefix + '-dynamic'
    }, extras);
}